import React from 'react';
import { Box, Chip, Paper } from '@mui/material';

interface Section {
  id: string;
  title: string;
}

interface SectionToolbarProps {
  sections: Section[];
  activeSection?: string;
}

export const SectionToolbar: React.FC<SectionToolbarProps> = ({
  sections,
  activeSection,
}) => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(`section-${sectionId}`);
    if (element) {
      const yOffset = -100;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: 1,
          paddingX: 3,
          paddingY: 1.5,
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            height: 8,
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,0.2)',
            borderRadius: 4,
          },
        }}
      >
        {sections.map(section => (
          <Chip
            key={section.id}
            label={section.title}
            onClick={() => scrollToSection(section.id)}
            color={activeSection === section.id ? 'primary' : 'default'}
            variant={activeSection === section.id ? 'filled' : 'outlined'}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                backgroundColor:
                  activeSection === section.id
                    ? 'primary.dark'
                    : 'action.hover',
              },
            }}
          />
        ))}
      </Box>
    </Paper>
  );
};
